import { render, staticRenderFns } from "./PxCalculoPercent.vue?vue&type=template&id=7bc8cdaf&"
import script from "./PxCalculoPercent.vue?vue&type=script&lang=js&"
export * from "./PxCalculoPercent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports